import React from 'react'
import * as moment from 'moment'
import { useHistory } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import { setLibraryActiveFile, changeLibraryModal, setActiveFileSettings, appendDeletionArray, subtractDeletionArray } from '../../../../../redux/actions/library'
import { ChangeIconButton, DeleteIconButton, InfoTableButton } from '../../../../library/button'
import { Checkbox } from '../../../../library/checkbox'

const Index = ({singleFile, index, arr }) => {

    const dispatch = useDispatch();
    const history = useHistory()
    const deletions = useSelector(state => state.library.deletionArray)

    const activeCompany = useSelector(state => state.activeCompany && state.activeCompany.activeCompany)


    const clickUnlockFile = key => {
        if(activeCompany.subscription){
            dispatch(setLibraryActiveFile(key))
            dispatch(changeLibraryModal({unlockModal: true}))
        }
    }

    const handleClickSettings = file => {
        if(activeCompany.subscription){
            dispatch(setActiveFileSettings(file))
            dispatch(changeLibraryModal({settingsModal: true}))
        }
    }

    const determineSettingsHoverButton = () => {
        if(!activeCompany){
            return "Du må velge et selskap før du kan utføre denne handlingen."
        }

        if(activeCompany && !activeCompany.subscription){
            return "Du må ha et aktivt abonnement for å kunne gjøre dette."
        }
    }

    const clickDeleteSingleFile = file => {
        if(activeCompany.subscription){
            dispatch(setLibraryActiveFile(file))
            dispatch(changeLibraryModal({deleteModal: true}))
        }
    }

    const displayNewFileType = type => {
        if(type){
            return type
        } else {
            return "unknown"
        }
    }

    const handleSingleSelection = (e, id) => {
        if(e.target.checked){
            if(!deletions.includes(id)){
                dispatch(appendDeletionArray(id))
            }
        } else {
            if(deletions.includes(id)){
                dispatch(subtractDeletionArray(id))
            }
        }
    }

    const determineSettingsDeleteButton = () => {
        if(!activeCompany){
            return "Du må velge et selskap før du kan utføre denne handlingen."
        }

        if(activeCompany && !activeCompany.subscription){
            return "Du må ha et aktivt abonnement for å kunne gjøre dette."
        }
    }

    const handleFileClick = file => {
        if(activeCompany.subscription && file.password){
            clickUnlockFile(file.key)
        } else {
            window.location.href = file.downloadLink
        }
    }

    return(
        <tr key={singleFile.key} className={index === (arr.length - 1) && "last"}>
            <td><Checkbox key={singleFile.key} fileId={singleFile.key} name="fileId" onChange={(e) => handleSingleSelection(e, singleFile.key)} checked={deletions.includes(singleFile.key) ? true:false} type="checkbox" id="select"/></td>
            <td onClick={() => handleFileClick(singleFile)}><span className="file-name">{singleFile.name}</span></td>
            <td onClick={() => handleFileClick(singleFile)}>{moment.unix(singleFile.timestamp).format('HH:MM DD/MM/YYYY')}</td>
			<td onClick={() => handleFileClick(singleFile)}>{singleFile.owner}</td>
            <td onClick={() => handleFileClick(singleFile)}><i className="fas fa-lock"></i> {singleFile.password ? 'Ja':'Nei'}</td>
            <td className="industry-label"><InfoTableButton color='blue' title={displayNewFileType(singleFile.type)}/></td>
            <td><ChangeIconButton data-tip={determineSettingsHoverButton()} onClick={() => handleClickSettings(singleFile)}/><DeleteIconButton data-tip={determineSettingsDeleteButton()} onClick={() => clickDeleteSingleFile(singleFile.key)}/></td>
        </tr>
    )
}

export default Index



